import { AnnouncementModalLayout, Text } from '@wix/design-system';
import React, { useEffect } from 'react';
import BusinessFirstIcon from '../../assets/images/businessFirst.svg';
import { reportModalCtaClick, reportModalShown } from '../../bi/bi';
import { Modals } from '../../types';
import { useLibraryTranslations } from '../../context/TranslationsContext';
import { useModalsAndWindow } from '../../context/ModalsAndWindowContext';
export const BusinessFirstModal = () => {
  const {
    t
  } = useLibraryTranslations();
  const {
    modals
  } = useModalsAndWindow();
  const {
    businessFirstUrl
  } = modals.businessFirst.modalProps;
  useEffect(() => {
    reportModalShown(Modals.businessFirst);
  }, []);
  return /*#__PURE__*/React.createElement(AnnouncementModalLayout, {
    dataHook: "business-first-modal-layout",
    illustration: /*#__PURE__*/React.createElement(BusinessFirstIcon, null),
    title: t('business-first-modal.title'),
    primaryButtonText: t('business-first-modal.primary-cta'),
    linkOnClick: () => {
      reportModalCtaClick({
        ctaName: 'i-will-do-it-later',
        modalType: Modals.businessFirst
      });
      modals.businessFirst.close({
        answer: 'PROCEED'
      });
    },
    linkText: t('business-first-modal.secondary-cta'),
    primaryButtonOnClick: () => {
      reportModalCtaClick({
        ctaName: 'create-site',
        modalType: Modals.businessFirst
      });
      window.open(businessFirstUrl);
      modals.businessFirst.close({
        answer: 'PROCEED'
      });
    },
    onCloseButtonClick: () => {
      reportModalCtaClick({
        ctaName: 'close',
        modalType: Modals.businessFirst
      });
      modals.businessFirst.close({
        answer: 'PROCEED'
      });
    }
  }, /*#__PURE__*/React.createElement(Text, null, t('business-first-modal.subtitle')));
};
//# sourceMappingURL=BusinessFirstModal.js.map